import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.AIAssistants.Title',
    defaultMessage: 'AI Assistants',
  },
  leslieName: {
    id: 'App.AIAssistants.LeslieName',
    defaultMessage: 'Leslie',
  },
  leslieDescription: {
    id: 'App.AIAssistants.LeslieDescription',
    defaultMessage:
      'Leslie is your AI leasing assistant. She texts prospects, answers ' +
      'questions, follows up automatically, and can mark unresponsive ' +
      'prospects as Dead.',
  },
  coraName: {
    id: 'App.AIAssistants.CoraName',
    defaultMessage: 'Cora',
  },
  coraDescription: {
    id: 'App.AIAssistants.CoraDescription',
    defaultMessage:
      'Cora is your AI compliance assistant. She reviews and processes ' +
      'affordable housing certifications, automatically follows up for ' +
      'missing documents and information, documents compliance findings, ' +
      'and prepares certifications for final compliance approval.',
  },
  on: {
    id: 'App.AIAssistants.On',
    defaultMessage: 'On',
  },
  off: {
    id: 'App.AIAssistants.Off',
    defaultMessage: 'Off',
  },
  errorHeader: {
    id: 'App.AIAssistants.ErrorHeader',
    defaultMessage: 'Error',
  },
  failedToLoadStatus: {
    id: 'App.AIAssistants.FailedToLoadStatus',
    defaultMessage: "Failed to load Leslie's status for this property",
  },
  failedToLoadCoraStatus: {
    id: 'App.AIAssistants.FailedToLoadCoraStatus',
    defaultMessage: "Failed to load Cora's status for this property",
  },
});

export default messages;
